module.exports = "<div ng-message=\"required\">To pole jest wymagane</div><div ng-message=\"pattern\">Niepoprawny nr telefonu</div>";


//////////////////
// WEBPACK FOOTER
// ./client/components/sf-ng-messages/sf-ng-messages.pug
// module id = 360
// module chunks = 0